import { render, staticRenderFns } from "./ContactHistory.vue?vue&type=template&id=a4a7df0a&scoped=true"
import script from "./ContactHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactHistory.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ContactHistory.vue?vue&type=style&index=0&id=a4a7df0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a7df0a",
  null
  
)

export default component.exports